import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { WrongFieldRouteComponent } from '@cropx-common/components/wrong-field-route/wrong-field-route.component';
import { ImpersonateComponent } from '@cropx-web/screens/impersonate/impersonate.component';

import { Page500ErrorComponent } from './screens/page-500-error/page-500-error.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import(`./modules/main-app/main.app.module`).then((m) => m.MainAppModule),
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import(`./modules/auth/auth.module`).then((m) => m.AuthModule),
  },
  { path: 'oops', component: WrongFieldRouteComponent },
  { path: 'error-500', component: Page500ErrorComponent },
  { path: 'loading', component: ImpersonateComponent },
  { path: '**', component: WrongFieldRouteComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
